// extracted by mini-css-extract-plugin
export default {"badge-button":"cTpgL","badgeButton":"cTpgL","badge":"gv-Cq"};